import { composeDetailSearchFilter } from 'utils/insightModal/composeDetailSearchFilter'
import { composeDrillDownWidgetSetting } from 'utils/insightModal/composeDrillDownWidgetSetting'
import { SearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/searchFilterComposingStrategy'
import { WidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/widgetSettingComposingStrategy'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getSelectionName } from 'components/insightContent/utils/utils'
import { InsightData } from 'schemas/action/InsightDataSchema'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from '../../../../../utils/widgetUtil'
import { AuthorsWidgetsType } from '../../types'

export const convertToInsightContentSetting = (
  widgetSetting: AuthorsWidgetsType,
  strategy: SearchFilterComposingStrategy,
  selection?: { insights?: Array<InsightData> }
) => {
  const { viewOption } = widgetSetting

  const insightContentSetting = ({
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos: widgetSetting.topicInfos!,
    drillDownTypes: ['INCLUDED_AUTHORS'],
    drillDownFilter: {} as AnalysisFilter,
    selectedTopicInfo: widgetSetting.selectedTopic,
    topicId: widgetSetting.selectedTopic.topicId!,
    insights: selection ? selection?.insights : null,
    displayTitleTooltip: true
  } as unknown) as InsightContentSettingType

  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  const insights = selection ? selection?.insights : null

  if (insights && insights.length > 0) {
    const filter = toFilter(widgetSetting)
    filter.includedAuthors = []
    filter.domains = []

    insightContentSetting.selectionName = getSelectionName(insights?.[0], viewOption)!
    if (insights.length > 1) {
      if (insights.length === 2) {
        insightContentSetting.selectionSecondName = getSelectionName(insights?.[1], viewOption)!
      }
    }

    insightContentSetting.selectionFilter = composeDetailSearchFilter(
      strategy,
      widgetSetting,
      insights
    )
  }
  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: AuthorsWidgetsType,
  strategy: WidgetSettingComposingStrategy,
  selection?: { insights?: Array<InsightData> }
) => {
  if (!widgetSetting || typeof widgetSetting !== 'object') {
    return {}
  }

  if (!selection) {
    return {}
  }

  const { insights } = selection

  return composeDrillDownWidgetSetting(strategy, widgetSetting, insights || [])
}
